var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_6495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4012 0.649798L8.77599 6.43573L2.15221 0.649798C2.42287 0.500831 2.72919 0.409912 3.0593 0.409912H14.4927C14.8228 0.409912 15.1291 0.500831 15.4012 0.649798ZM16.4355 10.7397C16.588 10.4697 16.6838 10.162 16.6838 9.83119V2.27445C16.6838 1.90448 16.5705 1.56248 16.3831 1.27084L11.5553 5.40065L16.4355 10.7397ZM10.8692 6.00491L9.30892 7.31204C9.21925 7.38624 9.10638 7.42659 8.99 7.42604C8.87362 7.42659 8.76075 7.38624 8.67108 7.31204L7.11078 6.00491L2.15221 11.3146C2.46049 11.5009 2.81378 11.5996 3.174 11.5999H14.806C15.1665 11.5997 15.52 11.501 15.8285 11.3146L10.8692 6.00491ZM1.29688 2.27445C1.29688 1.90448 1.41017 1.56248 1.59761 1.27084L6.42539 5.39995L1.54515 10.7397C1.39199 10.4697 1.29688 10.162 1.29688 9.83119V2.27445Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3862,
    height: 11.19,
    fill: "white",
    transform: "translate(1.29688 0.409912)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.c50952478a7c8c355eaa7c08858ab6ff.svg";
export { ForwardRef as ReactComponent };